import React, { FC } from 'react';
import theme from '@buoyhealth/common.buoy-theme';

type TeleMedicineIconProps = {
  className?: string;
  color?: string;
};

const TeleMedicineIcon: FC<TeleMedicineIconProps> = ({
  className = '',
  color = theme.palette.primary.main,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
    className={className}
  >
    <mask id="path-1-inside-1_439_9106" fill="white">
      <rect x="10.3652" width="12.878" height="21.0732" rx="1" />
    </mask>
    <rect
      x="10.3652"
      width="12.878"
      height="21.0732"
      rx="1"
      stroke={color}
      strokeWidth="3"
      mask="url(#path-1-inside-1_439_9106)"
    />
    <circle cx="16.8026" cy="6.43907" r="2.14634" fill={color} />
    <path
      d="M13.2285 10.5853C13.2285 9.48076 14.1239 8.58533 15.2285 8.58533H18.383C19.4876 8.58533 20.383 9.48076 20.383 10.5853V12.878H13.2285V10.5853Z"
      fill={color}
    />
    <path d="M14.6562 16.9106H18.9489" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M11.08 7.02441C11.08 4.68294 7.43902 4.68296 7.43902 7.02443L6.85366 13.4635L1 17.561M12.7073 20.4878L8.02439 24"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M23.2439 7.02434C25.5854 7.02434 25.5854 3.51215 23.2439 3.51215"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M23.2439 10.5366C25.5854 10.5366 25.5854 7.02441 23.2439 7.02441"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M23.2439 14.0488C25.5854 14.0488 25.5854 10.5366 23.2439 10.5366"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M23.2439 17.561C25.5854 17.561 25.5854 14.0488 23.2439 14.0488"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);

export default TeleMedicineIcon;
